import React, {Component} from 'react';
import Xeniagraphy from "./xeniagraphy";
import moment from 'moment';
import config from '../config.json';

class XeniagraphyList extends Component {

    constructor(props) {
        super(props);
    }

    handleOpenWebViewModal = (iframeSrc,modalTitle,websiteUrl,familyUri) => {
        this.props.openWebViewModal(iframeSrc,modalTitle,websiteUrl,familyUri);
    }

    renderList = () => {
        const items = this.props.masterSubjects;
        return items.map((ms, index) => {
            return <Xeniagraphy key={index} showDistance={this.props.showDistance} handleOpenWebViewModal={this.handleOpenWebViewModal} masterSubject={ms}/>
        })
    }

    loadNextItems = (e) => {
        e.preventDefault();
        this.props.loadNext();
    }

    render() {
        let lastUpdateDate = '', widgetUrl_local = '';
        if (this.props.masterSubjects && this.props.masterSubjects.length > 0) {
            const ms = this.props.masterSubjects[0];
            lastUpdateDate = moment(this.props.masterSubjects[0].lastUpdateDate).format('DD/MM/YYYY')
            widgetUrl_local = config.widgetUrl_local + "/" + ms.uri.split('#')[1] + "/" + ms.templateIdCreatedFrom;
        }
        return (
            <div className="container" style={{marginBottom : '30px'}}>
                <div className="row ">
                    <div className="col-md-12">
                        <div className="templatemo_home_botright">
                            <div id="tabs">
                                <div id="tabs-1">
                                    <div className="templatemo_popular_wrapper">
                                        {this.renderList()}
                                        {
                                            this.props.showPagination ? <div>
                                                <span onClick={(e) => this.loadNextItems(e)} className="load-next">Voir plus...</span>
                                            </div> : null
                                        }
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default XeniagraphyList;